import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  clickable?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  className = '', 
  onClick,
  clickable = false 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-20 h-20'
  };

  const handleClick = () => {
    if (clickable && onClick) {
      onClick();
    }
  };

  return (
    <div 
      className={`${sizeClasses[size]} ${className} relative ${
        clickable ? 'cursor-pointer hover:scale-105 transition-transform duration-200' : ''
      }`}
      onClick={handleClick}
    >
      {/* Container da imagem */}
      <div className="w-full h-full rounded-lg flex items-center justify-center overflow-hidden">
        <img 
          src="/logo.png" 
          alt="MasterClub Logo" 
          className="w-full h-full object-cover object-center"
          style={{ objectFit: 'contain' }}
        />
      </div>
    </div>
  );
};

export default Logo;